import { render, staticRenderFns } from "./SignatureBox.vue?vue&type=template&id=05966f86"
import script from "./SignatureBox.vue?vue&type=script&lang=js"
export * from "./SignatureBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports